import { render, staticRenderFns } from "./newProductList.vue?vue&type=template&id=b0f638ba"
import script from "./newProductList.vue?vue&type=script&lang=js"
export * from "./newProductList.vue?vue&type=script&lang=js"
import style0 from "./newProductList.vue?vue&type=style&index=0&id=b0f638ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports